import React from "react";
import styles from "./WhyChoose.module.css";
import CountUp from "react-countup";

const WhyChoose = () => {
  const stats = [
    { number: "120000+", label: "Happy Students" },
    { number: "1000000", label: "Sessions Completed" },
    { number: "120+", label: "Mentors" },
    { number: "240+", label: "Schools" },
  ];

  const features = [
    {
      icon: "🏫",
      title: "Master Centers",
      description:
        "in Indiranagar & Whitefield Students from 8 Countries for online STEM program Strong presence in Bangalore, India",
    },
    {
      icon: "🤝",
      title: "Network",
      description:
        "Hot Training & Sales team in Bangalore to support you Good network with schools community in Bangalore Good network with parents community in Bangalore",
    },
    {
      icon: "🌐",
      title: "Presence",
      description:
        "Grand social media presence with 35,000+ followers in Instagram, 10,000+ followers in Facebook, 5000+ followers in LinkedIn, 23,000+ subscribers in YouTube and 5k + daily visitors to our website.",
    },
  ];

  return (
    <section className={styles.whyChoose}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Why choose us?</h2>

        <div className={styles.stats}>
          {stats.map((stat, index) => (
            <div
              key={index}
              className={styles.stat}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <h3>
                <CountUp
                  end={parseInt(stat.number)}
                  duration={2.5}
                  separator=","
                  suffix={stat.number.includes("+") ? "+" : ""}
                />
              </h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>

        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.iconWrapper}>{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
